<div class="loadding-container">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</div>